import React from 'react';
import {
  Box,
  Drawer,
  Toolbar,
  Typography,
  Divider,
  useTheme,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { Navigation, AdminNavigation } from '../Navigation/Navigation';
import { SidebarProps } from '../layout.types';

export const Sidebar: React.FC<SidebarProps> = ({
  mobileOpen,
  drawerOpen,
  onMobileDrawerToggle,
  navigationItems,
  adminNavigationItems,
  drawerWidth,
  onNavigate,
  isItemVisible,
}) => {
  const { t } = useTranslation();
  const location = useLocation();
  const theme = useTheme();

  const drawer = (
    <Box>
      <Toolbar>
        <Typography variant="h6" noWrap component="div">
          {t('dashboard.title')}
        </Typography>
      </Toolbar>
      <Divider />
      
      <Navigation
        items={navigationItems}
        onNavigate={onNavigate}
        currentPath={location.pathname}
        isItemVisible={isItemVisible}
      />
      
      <AdminNavigation
        items={adminNavigationItems}
        onNavigate={onNavigate}
        currentPath={location.pathname}
        isItemVisible={isItemVisible}
      />
    </Box>
  );

  return (
    <Box
      component="nav"
      sx={{ 
        width: { 
          xs: 0,
          md: drawerOpen ? drawerWidth : 0 
        }, 
        flexShrink: { md: 0 },
        transition: theme.transitions.create('width', {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.leavingScreen,
        }),
      }}
    >
      {/* Mobile Drawer */}
      <Drawer
        variant="temporary"
        open={mobileOpen}
        onClose={onMobileDrawerToggle}
        ModalProps={{
          keepMounted: true,
        }}
        sx={{
          display: { xs: 'block', md: 'none' },
          '& .MuiDrawer-paper': { 
            boxSizing: 'border-box', 
            width: drawerWidth 
          },
        }}
      >
        {drawer}
      </Drawer>
      
      {/* Desktop Drawer */}
      <Drawer
        variant="persistent"
        anchor="left"
        open={drawerOpen}
        sx={{
          display: { xs: 'none', md: 'block' },
          '& .MuiDrawer-paper': { 
            boxSizing: 'border-box', 
            width: drawerWidth,
            position: 'relative',
            transition: theme.transitions.create('transform', {
              easing: theme.transitions.easing.sharp,
              duration: theme.transitions.duration.enteringScreen,
            }),
          },
        }}
      >
        {drawer}
      </Drawer>
    </Box>
  );
};
